export default __webpack_public_path__ + "static/media/team1.6cd8955b.png";